export const onResize = (setIsTabletView) => {
  function updateSize() {
    setIsTabletView(window.innerWidth < 1280);
  }
  window.addEventListener('resize', updateSize);
  updateSize();

  return () => window.removeEventListener('resize', updateSize);
};
